import { dataFetcher, endpoints } from 'Api';
import AlterImage from 'Assets/alter-image.png';

// Maps a group's detail response to carousel/grid items ({ id, image, text }).
// The id is needed to drag-reorder the contents (reorderItem parent_id/item_id).
export const loadRowContent = async ({
  reorderType, itemId, userId, limit = 24,
}) => {
  const base = { limit, start: 0 };
  const videoItems = (videos) => (videos || []).map((v) => ({
    id: v.id || v.content_id || v.video_id || v.draft_id,
    image: v.imagekit_icon || v.thumbnails?.[0] || v.thumbnail || AlterImage,
    text: v.title || '',
  }));
  if (reorderType === 'category') {
    const res = await dataFetcher(endpoints.getCategoryDetail, {
      user_id: userId, category_id: itemId, vpm: false, ...base,
    });
    return videoItems(res?.videos);
  }
  if (reorderType === 'playlist') {
    const res = await dataFetcher(endpoints.getMyPlaylist, { playlist_id: itemId, vpm: false, ...base });
    return videoItems(res?.data?.[0]?.videos);
  }
  const res = await dataFetcher(endpoints.getMyAlbumDetail, { album_id: itemId, ...base });
  const data = res?.data?.[0] || res?.data;
  return (data?.photos || []).map((p) => ({
    id: p.id || p.photo_id,
    image: p.imagekit_url || p.image || AlterImage,
    text: p.title || '',
  }));
};

// reorderItem `type` for the CONTENTS inside a group (videos/photos).
export const contentReorderType = (reorderType) => (reorderType === 'album' ? 'album_photo' : `${reorderType}_video`);
